import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiPublicPromoCodeService from "../../../../core/api/api.publicPromoCode";
import ApiPromoCodeService from "../../../../core/api/api.promoCode";

import publicApi from "../../../../core/api/api.public";

import SwalMessage from "../../_Components/SwalMessage";
import { useNavigate, useLocation } from "react-router-dom";
import { MenuItem } from "@mui/material";
import moment from "moment-jalaali";
import { tools } from "../../../../core/utils/tools";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import { DateObject } from "react-multi-date-picker";
import { persian } from "../../_Components/customLocale";
// moment.locale("fa");
// moment.loadPersian();
const selectStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 10000,
  }),
};

export const NewPublicPromoCodeModal = ({
  showModalPromoCode,
  setShowModalPromoCode,
  selectedPromoCodeId,
}) => {
  let location = useLocation();
  let navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      promoCodeId: 0,
    },
  });

  const [listData, setListData] = useState([]);
  const [allAgentList, setAllAgentList] = useState([]);
  const [allCommisionList, setAllCommisionList] = useState([]);
  const [locationS, setlocationS] = useState(location?.state?.promoCodeId);
  const [copySuccess, setCopySuccess] = useState(null);
  const [promoCodeActive, setPromoCodeActive] = useState(false);
  const [selectDatePicker, setSelectDatePicker] = useState();
  const [promoCodeSelectedReadOnly, setpromoCodeSelectedReadOnly] =
    useState(false);
  const [statusEditField, setstatusEditField] = useState(false);
  let handleClose = (e) => {
    setShowModalPromoCode(false);

    //e.stopPropagation();
    // navigate(-1);
    // location?.state?.promoCodeId ?props.callback(null) :props.callback(getValues("Code"));
  };
  useEffect(() => {
    (async () => {
      try {
        const resultPromoCategory =
          await ApiPromoCodeService.getAllPromoCategory({
            TypePromoCategory: 2,
          });
        setListData(resultPromoCategory);
        if (selectedPromoCodeId != 0) {
          let promoCodeById = ApiPublicPromoCodeService.get(
            selectedPromoCodeId
          ).then((rest) => {
            // if (rest.created != "0001-01-01T00:00:00") {
            //     let dateCreated =rest.created.split(' ')[0];
            //                 let restgetDateTimeAddDay= publicApi.getDateTimeAddDay({addDay:21,createTime:dateCreated}).then(resultdate => {
            //         //console.log("resultdate ",resultdate)
            //         let splitgetDateOfServer = resultdate.dateTime.split('/');
            //         let splitdateTimeAfterXDays = resultdate.dateTimeAfterXDays.split('/');
            //        let  minimumDateV={
            //             year: parseInt(splitgetDateOfServer[0]),
            //             month:parseInt( splitgetDateOfServer[1]),
            //             day: parseInt( splitgetDateOfServer[2])
            //           };
            //         let  maximumDateV={
            //            year: parseInt( splitdateTimeAfterXDays[0]),
            //            month:parseInt(  splitdateTimeAfterXDays[1]),
            //            day: parseInt( splitdateTimeAfterXDays[2])
            //          };
            //           setValue("minimumDate",minimumDateV);
            //           setValue("maximumDate",maximumDateV);

            //             setValue("expireDate",maximumDateV);

            //             //console.log("minimumDateV ", getValues("minimumDateCheckin") ,getValues("maximumDateCheckOut"))

            // })
            // }else{

            // }
            const expireDate = tools.checkInputDateAndReturnProperFormattedDate(
              rest.expireDate
            );
            setValue("expireDate", expireDate);
            setValue("PromoCategoryId", rest.promoCategory.id);
            setValue("Code", rest.code);
            setValue("promoCodeId", rest.id);
            setValue("promoCodePublicationName", rest.promoCodePublicationName);
            setpromoCodeSelectedReadOnly(rest.used ? true : false);
            setstatusEditField(true);
            setPromoCodeActive(true);
          });
        } else {
          const { formattedArbitaryDate: formatted90DaysFromNow } =
            tools.setCustomDate(90);
          setValue("expireDate", formatted90DaysFromNow);

          // let rest= publicApi.getDateTimeAddDay({addDay:90,createTime:""}).then(resultdate => {
          //     console.log("restDateJalalisystem :>> ", resultdate );

          //          let splitgetDateOfServer = resultdate.dateTime.split('/');
          //          let splitdateTimeAfterXDays = resultdate.dateTimeAfterXDays.split('/');
          //         let  minimumDateV={
          //              year: parseInt(splitgetDateOfServer[0]),
          //              month:parseInt( splitgetDateOfServer[1]),
          //              day: parseInt( splitgetDateOfServer[2])
          //            };
          //          let  maximumDateV={
          //             year: parseInt( splitdateTimeAfterXDays[0]),
          //             month:parseInt(  splitdateTimeAfterXDays[1]),
          //             day: parseInt( splitdateTimeAfterXDays[2])
          //           };
          //           setValue("minimumDate",minimumDateV);
          //           setValue("maximumDate",maximumDateV);
          //            setValue("expireDate",maximumDateV);

          //     })
        }
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => {};
  }, []);

  const onSubmit = async (data) => {
    try {
      if (!_.isUndefined(data.expireDate)) {
        if (typeof data.expireDate == "object")
          data.expireDate = moment(
            data.expireDate.year +
              "/" +
              ("0" + data.expireDate.month).slice(-2) +
              "/" +
              ("0" + data.expireDate.day).slice(-2),
            "jYYYY/jM/jD"
          ).format("YYYY-M-D");
        else
          data.expireDate = moment(data.expireDate, "jYYYY/jMM/jDD").format(
            "YYYY-M-D"
          );
      }
      const resultPromoCategory =
        await ApiPublicPromoCodeService.createandEditPublicPromoCode({
          InputPromoCode: data,
        });
      if (resultPromoCategory.succeeded) {
        SwalMessage({
          title:
            resultPromoCategory.data == 1
              ? JSON.parse(resultPromoCategory.message).Message
              : resultPromoCategory.message,
          iSsuccess:
            resultPromoCategory.data == 1 || resultPromoCategory.data == 2
              ? true
              : false,
          timer: 10000,
        });
      } else {
        SwalMessage({
          title: resultPromoCategory.message,
          iSsuccess: resultPromoCategory.succeeded,
          timer: 5000,
        });
      }
      resultPromoCategory.data == 1 &&
        setValue(
          "promoCodeId",
          JSON.parse(resultPromoCategory.message).promoCodeId
        );

      if (resultPromoCategory.data == 1) {
        setValue("Code", JSON.parse(resultPromoCategory.message).PromoCode);
        setPromoCodeActive(true);
        document.getElementById("submitButton").click();
      }
      handleClose();
    } catch (error) {
      console.log("error=", error);
    }
  };

  function handleChangeMulti(event) {
    setValue("agentName", event);
  }

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess("Copied!");
    } catch (err) {
      setCopySuccess("Failed to copy!");
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalPromoCode} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedPromoCodeId != 0
                ? "ویرایش کد تخفیف عمومی"
                : "ایجاد کد تخفیف عمومی جدید "}{" "}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {promoCodeActive && (
              <Col xs="12">
                <Controller
                  name="Code"
                  control={control}
                  rules={{}}
                  render={({ field: { onChange, value } }) => (
                    <div className="d-flex align-items-center">
                      <TextField
                        label="کد تخفیف"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        disabled
                      />

                      <span
                        className="btn btn-light-primary btn-sm ml-2 btn-icon mt-2 "
                        onClick={(e) => copyToClipBoard(getValues("Code"))}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-dark"
                        title="کپی تو کلیپ بورد"
                        data-bs-delay-hide="1000"
                      >
                        <i class="fas fa-clipboard"></i>
                      </span>
                    </div>
                  )}
                />
              </Col>
            )}
            <Col xs="12" className="mt-5">
              <Controller
                name="expireDate"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <ShamsiDatePicker
                    value={value}
                    onChange={onChange}
                    placeholder="تاریخ انقضا"
                    disabled={statusEditField}
                    minDate={new DateObject({ calendar: persian })}
                    maxDate={new DateObject({ calendar: persian }).add(
                      90,
                      "days"
                    )}
                  />
                )}
              />
              {/* <Controller
                                    name="expireDate"
                                    control={control}
                                    rules={{  }}
                                    style={{zIndex:'200 !important'}}
                                    render={({ field: { onChange, value } }) => (
                                        <DatePicker
                                        value={value}
                                        onChange={onChange}
                                        locale="fa"
                                        shouldHighlightWeekends
                                        minimumDate={getValues("minimumDate")}
                                        maximumDate={getValues("maximumDate")}
                                      
                                        
                                        renderInput={(props) => {
                                          return (
                                            <TextField
                                              {...props}
                                              mask="____/__/__"
                                              value={
                                                value
                                                  ? `${value.year +
                                                  `/` +
                                                  ("0" + value.month).slice(-2) +
                                                  `/` +
                                                  ("0" + value.day).slice(-2)}`
                                                  : ""
                                              }
                                              className="w-100"
                                              variant="outlined"
                                              label="تاریخ انقضا"
                                              size="small"
                                              margin="normal"
                                              disabled={statusEditField}
                                        //    style={selectStyles}

                                        onClick={()=>{setSelectDatePicker("expireDate")}}
                                     
                                            // onChange={onChange}
                                            />
                                          );
                                        }}
                                      />
                                    )}
                                /> */}
            </Col>

            <Col xs="12" className="mt-2">
              <Controller
                name="PromoCategoryId"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    select
                    label="انتخاب گروه تخفیف"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    disabled={promoCodeSelectedReadOnly}
                    className={`mb-1 require_input ${errors.PromoCategoryId && "required_error_input"}`}
                  >
                    {listData?.map(
                      (item, index) =>
                        item.isActive == true && (
                          <MenuItem key={index} value={item.id}>
                            {item.promoCategoryName}{" "}
                          </MenuItem>
                        )
                    )}
                  </TextField>
                )}
              />

              {errors.PromoCategoryId && (
                <span class="mt-2  text-danger">
                  لطفا گروه تخفیف را وارد نمایید
                </span>
              )}
            </Col>

            <Col xs="12" className="mt-1">
              <Controller
                name="promoCodePublicationName"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="نام کد تخفیف"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    className={`mb-1 require_input ${errors.promoCodePublicationName && "required_error_input"}`}
                    onChange={onChange}
                  />
                )}
              />
              {errors.promoCodePublicationName && (
                <span class="mt-2  text-danger">
                  نام کد تخفیف را وارد نمایید
                </span>
              )}
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon />
              ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
